// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mTkI","title":"styles_title__3CKXK"};